import { CaseReducer, PayloadAction } from '@reduxjs/toolkit'
import { BoMItemRow, BomItemType } from 'model/Project/BoMItemRow'
import { BomItemPointer } from 'model/Project/BomItemPointer'
import { BoMItemActivityDto } from 'services/APIs/InternalAPI/internal-api.contracts'
import { ProjectState } from '../../../../store/Project/ProjectTypes'
import { bomItemSelector } from '../selectors/bomItemSelector'

export const addActivityToBomItem: CaseReducer<
  ProjectState,
  PayloadAction<{
    bomItemPointer: BomItemPointer
    workingStep: BoMItemActivityDto
  }>
> = (state, action) => {
  if (action.payload.bomItemPointer.id === state.activeProject?.id) {
    state.activeProject.activities.push(action.payload.workingStep)
    return state
  }

  const bomItem = bomItemSelector(
    { project: state },
    action.payload.bomItemPointer,
  )

  updateBomItem(bomItem)

  return state

  function updateBomItem(bomItem: BoMItemRow): void {
    switch (bomItem?.type) {
      case BomItemType.assemblyType:
      case BomItemType.assemblyInstance: {
        const existingIdx = bomItem.assemblyActivities.findIndex(
          (x) => x.id === action.payload.workingStep.id,
        )
        if (existingIdx > -1) {
          bomItem.assemblyActivities[existingIdx] = action.payload.workingStep
        } else {
          bomItem.assemblyActivities.push(action.payload.workingStep)
        }
        break
      }
      case BomItemType.project:
      case BomItemType.partType:
      case BomItemType.partInstance: {
        const existingIdx = bomItem.activities.findIndex(
          (x) => x.id === action.payload.workingStep.id,
        )
        if (existingIdx > -1) {
          bomItem.activities[existingIdx] = action.payload.workingStep
        } else {
          bomItem.activities.push(action.payload.workingStep)
        }
        break
      }
    }
  }
}
